var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "group-dropdown",
      class: {
        selected: _vm.isValueInOptions
      },
      attrs: { tabindex: _vm.isOpen ? -1 : 0 },
      on: {
        mouseenter: function($event) {
          return _vm.$emit("update", true)
        },
        mouseleave: function($event) {
          return _vm.$emit("update", false)
        },
        focus: function($event) {
          return _vm.$emit("update", true)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "header", on: { click: _vm.selectDefault } },
        [_vm._t("header")],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen"
            }
          ],
          staticClass: "group-dropdown-options"
        },
        [
          _vm._l(_vm.options, function(option) {
            return [_vm._t("option", null, { option: option })]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }